<template>  
  <h2>  :: Acesso não autorizado ::  </h2> 
</template>
<script>
export default {

}
</script>
<style>
</style>



// WEBPACK FOOTER //
// SemPermissao.vue?2dd3b467